import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EdpService } from '../services/edp.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  registrar: boolean = false;

  constructor(private route: Router, private service: EdpService) {}

  ngOnInit(): void {
    this.registrar = this.service.UsuarioRegistra();
  }

  cerrarSesion() {
    sessionStorage.removeItem('edpp-token');
    this.route.navigate(['/login']);
  }

  inicio() {
    this.route.navigate(['/']);
  }

  alumnos() {
    this.route.navigate(['/lista-alumnos']);
  }
}
